module.exports = __webpack_public_path__ + "img/07.bc4f93d6.png";